module.exports = __webpack_public_path__ + "assets/maritime-black.5b73c48c.svg";